export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/services/personal', 'service-provider.personal-services')
    .when('/service-provider/services/corporate', 'service-provider.corporate-services')

    .within('service-provider')

    .segment('personal-services', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.services'
      }],
      template: '<service-provider-personal-services-page></service-provider-personal-services-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-personal-services.module" */ "./personal/service-provider-personal-services.module");
      }
    })

    .segment('corporate-services', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.services'
      }],
      template: '<service-provider-corporate-services-page></service-provider-corporate-services-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-corporate-services.module" */ "./corporate/service-provider-corporate-services.module");
      }
    });
}
